var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { CircularProgress, Box, useTheme, useMediaQuery } from '@mui/material';
import React, { useEffect } from 'react';
export var DefaultContent = function (_a) {
    var children = _a.children, _b = _a.loading, loading = _b === void 0 ? false : _b, _c = _a.height, height = _c === void 0 ? '100%' : _c, _d = _a.width, width = _d === void 0 ? '100%' : _d;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    useEffect(function () {
    }, [loading]);
    return (_jsx(_Fragment, { children: loading ? (_jsx(Box, __assign({ sx: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: width,
                height: height,
                overflow: 'hidden',
                padding: isMobile ? 1 : 2,
                minHeight: isMobile ? '200px' : '300px'
            } }, { children: _jsx(CircularProgress, { size: isMobile ? 30 : 40 }) }))) : (_jsx(Box, __assign({ sx: {
                width: '100%',
                maxWidth: '100%',
            } }, { children: children }))) }));
};
